import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Card } from 'reactstrap';

export const formatDateTime = (value) => (value ? moment(value).format('DD-MM-YYYY LT') : '');
export const formatLitres = (value) => (value || value === 0 ? `${value}L` : '');

// One blocky, touch-friendly card per receipt: View receipt on the left, the receipt details in
// the middle, and a caller-supplied action on the right (a select button, an unassign button, or a
// checkbox for multi-select) — big enough to tap on a phone. Shared by SelectReceiptModal
// (delivery, single-select) and SelectCollectionReceiptsModal (collection, multi-select).
const ReceiptCard = ({ receipt, action, showTank, onView }) => {
    const litres = receipt.litres != null ? receipt.litres : receipt.deliveryTotal;
    return (
        <Card body className="mb-2 p-2">
            <div className="d-flex align-items-center justify-content-between">
                <Button color="link" className="p-0 text-left flex-shrink-0" onClick={() => onView(receipt)}>
                    <i className="fa fa-file-text-o fa-lg" /><br />
                    <small>View</small>
                </Button>
                <div className="text-center px-2 flex-grow-1">
                    <div className="h5 mb-0">{formatLitres(litres)}</div>
                    <small className="text-muted">{formatDateTime(receipt.receivedAt)}</small>
                    {showTank && receipt.tankId ? <div><small className="text-muted">Tank #{receipt.tankId}</small></div> : null}
                    {receipt.address ? <div><small className="text-muted">{receipt.address}</small></div> : null}
                </div>
                <div className="flex-shrink-0">
                    {action}
                </div>
            </div>
        </Card>
    );
};

ReceiptCard.propTypes = {
    receipt: PropTypes.object.isRequired,
    action: PropTypes.node,
    showTank: PropTypes.bool,
    onView: PropTypes.func.isRequired,
};

export default ReceiptCard;
